
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking",
      function () {
        return require("private-next-pages/booking.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking"])
      });
    }
  